import React from "react";
import { View } from "react-native";
import { StyleSheet } from "@/utils/appStyleSheet";
import Icons from "@/assets/icons";
import Animated, {
  useAnimatedStyle,
  SharedValue,
} from "react-native-reanimated";

interface WelcomeSlideNew1Props {
  progress?: SharedValue<number>;
}

export default function WelcomeSlideNew1({ progress }: WelcomeSlideNew1Props) {
  const progressBarStyle = useAnimatedStyle(() => ({
    width: progress ? `${progress.value * 100}%` : "0%",
  }));

  return (
    <View style={styles.container}>
      <View style={styles.content}>
        <Icons.LogoGreen width={54} height={51} />
        <View style={styles.progressBarContainer}>
          <View style={styles.progressBarBg}>
            <Animated.View style={[styles.progressBarFill, progressBarStyle]} />
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  content: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  progressBarContainer: {
    marginTop: 24,
    width: 130,
  },
  progressBarBg: {
    height: 6,
    borderRadius: 100,
    backgroundColor: "rgba(15, 145, 41, 0.2)",
    overflow: "hidden",
  },
  progressBarFill: {
    height: 6,
    borderRadius: 100,
    backgroundColor: "#0F9129",
  },
});
